import React, { Component } from 'react';
import { Row, Col, Button, Modal, ModalHeader, ModalFooter, FormGroup, Label, Input, ModalBody } from 'reactstrap';

class JustificativaReaberturaComponent extends Component {
    render() {
        const { show, toggle, change, justificativa, reabrir } = this.props;
        return <Modal isOpen={show} toggle={toggle}>
            <ModalHeader toggle={toggle}>Reabertura do Mapa macroscópico</ModalHeader>
            <ModalBody>
                <Row>
                    <Col>
                        <FormGroup className="justificativa">
                            <Label>Informe uma justificativa para a reabertura do mapa</Label>
                            <Input type="textarea" name="text" placeholder="Justificativa para a reabertura"
                                onChange={change} value={justificativa} />
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button onClick={toggle} color="secondary">Voltar</Button>
                <Button onClick={reabrir} disabled={!justificativa} color="primary">Reabrir o mapa</Button>
            </ModalFooter>
        </Modal>
    }
}

export default JustificativaReaberturaComponent


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/macroscopia/operacoes/blocos/modal/justificativa-reabertura.component.js